import {useEffect, useState} from "react";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import st from "@/styles/Ui.module.scss";

const NoClick = () => {
    const [open, set_open] = useState<boolean>(false)
    const open_handler = (x:boolean) => {
        set_open(x)
    }
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.CustomEvents.session_expired, open_handler)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.session_expired, open_handler)
        }
        
    }, []);
    
    return open && (
        <div className={st.no_click} />
    )
}

export default NoClick